import { useState } from "react";
import { G } from "@/brand";
import api, { apiError } from "@/lib/api";
import { Heart } from "lucide-react";

const TIPS = [
  { id: "coffee", label: "Buy a coffee", amount: "$3" },
  { id: "supporter", label: "Supporter", amount: "$5" },
  { id: "fan", label: "Big fan", amount: "$10" },
  { id: "patron", label: "Patron", amount: "$25" },
];

export function DonationModal({ open, onClose }) {
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");

  if (!open) return null;

  const give = async (id) => {
    setError(""); setLoading(id);
    try {
      const { data } = await api.post("/donate", { package_id: id, origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      setError(apiError(e.response?.data?.detail) || e.message);
      setLoading("");
    }
  };

  return (
    <div data-testid="donation-modal" onClick={onClose} style={overlay}>
      <div onClick={(e) => e.stopPropagation()} style={{ ...box, position: "relative" }}>
        <button onClick={onClose} style={closeBtn}>×</button>
        <div className="mono" style={{ fontSize: 9, letterSpacing: "0.5em", color: G.gold, marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
          <Heart size={13} /> SUPPORT PROMPT SAVANT
        </div>
        <div style={{ fontSize: 24, fontWeight: 300, fontStyle: "italic", color: "#fff", marginBottom: 10 }}>
          Free forever — tips keep it that way.
        </div>
        <div style={{ color: G.muted, fontSize: 14, fontStyle: "italic", marginBottom: 24, lineHeight: 1.6 }}>
          If the free prompts helped you make something great, a small tip funds new genres and prompts. No account needed.
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {TIPS.map((t) => (
            <button key={t.id} data-testid={`donate-${t.id}`} onClick={() => give(t.id)} disabled={!!loading}
              className="tier-card" style={{ background: G.panel, border: `1px solid ${G.border}`, padding: "18px 14px", cursor: "pointer", textAlign: "center" }}>
              <div style={{ fontSize: 26, fontWeight: 700, color: G.gold }}>{loading === t.id ? "…" : t.amount}</div>
              <div className="mono" style={{ fontSize: 8, letterSpacing: ".12em", color: G.goldDim, marginTop: 6 }}>{t.label.toUpperCase()}</div>
            </button>
          ))}
        </div>
        {error && <div className="mono" style={{ color: "#ff5555", fontSize: 11, marginTop: 14 }}>{error}</div>}
      </div>
    </div>
  );
}

const overlay = { position: "fixed", inset: 0, zIndex: 999, background: "rgba(0,0,0,.85)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 };
const box = { background: G.dark, border: `1px solid ${G.borderHot}`, padding: "40px 36px", maxWidth: 440, width: "100%" };
const closeBtn = { position: "absolute", top: 14, right: 20, background: "none", border: "none", color: G.muted, cursor: "pointer", fontSize: 24, lineHeight: 1 };
